module.exports = __webpack_public_path__ + "static/img/logo-3-1.445c9de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-3-1.svg
// module id = WThe
// module chunks = 0